import { z } from "zod";
import { DmaSettingParameterKind } from "./dma-setting-parameter-kind.schema";
export const dmaSettingNumberRangeParameterDtoSchema = z.object({
    kind: z.literal(DmaSettingParameterKind.NumberRange),
    name: z.string(),
    from: z.number(),
    to: z.number(),
    step: z.number(),
});
